import { Dialog, Grid2 } from "@mui/material";
import { useEffect } from "react";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../Hooks/useWorker";
import { postUserId } from "../../../../store/actions/users/postUsers";
import { UIactions } from "../../../../store/slices/UI";
import { workerActions } from "../../../../store/slices/workers";
import BasicDialogActions from "../../../UI/BasicDialog/BasicDialogActions";
import BasicDialogContent from "../../../UI/BasicDialog/BasicDialogContent";
import BasicDialogTitle from "../../../UI/BasicDialog/BasicDialogTitle";
import Close from "./Components/Close";
import ColumnsList from "./Components/ColumnsList/ColumnsList";
import { newUsersUI } from "./Components/TopBar/UploadSheet";

const UITextHeader = {
  "es-CL": "Columnas visibles",
  "en-US": "Visible columns",
};

const ToggleReportColumns = () => {
  const { dispatch, settings, UI } = useUIBp();
  const { done } = useWorker(postUserId);
  const locale = settings.locale;
  const header = UITextHeader[locale];
  const users = UI[newUsersUI] ?? [];

  useEffect(() => {
    if (done) {
      dispatch(UIactions.openModal({ type: "download-creation-report" }));
    }
  }, [dispatch, done]);

  useEffect(() => {
    return () => {
      dispatch(UIactions.clear(newUsersUI));
      dispatch(workerActions.clear(postUserId));
    };
  }, [dispatch]);

  const onClose = (e, reason) => {
    console.log("reason", reason);
    if (reason !== "backdropClick") {
      dispatch(UIactions.closeModal());
    }
  };

  return (
    <Dialog fullWidth {...{ open: true, onClose, maxWidth: "sm" }}>
      <BasicDialogTitle {...{ header }} />
      <BasicDialogContent>
        <Grid2 container {...{ sx: { width: "100%" } }}>
          <ColumnsList />
          {/* <TopBar /> */}
          {/* {!!users.length ? <UsersList /> : <Empty />} */}
        </Grid2>
      </BasicDialogContent>
      <BasicDialogActions>
        <Close />
      </BasicDialogActions>
    </Dialog>
  );
};

export default ToggleReportColumns;
